<app-header *ngIf="!isAuthPage"></app-header>
<main class="min-h-screen">
  <router-outlet></router-outlet>
</main>
<app-footer *ngIf="!isAuthPage"></app-footer>
